import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolbarSize } from '@atlaskit/editor-common/types';
import { getIndentationButtonsState } from './pm-plugins/indentation-buttons';
import ToolbarListsIndentation from './ui';
export var toolbarListsIndentationPlugin = function toolbarListsIndentationPlugin(_ref) {
  var _api$featureFlags, _api$primaryToolbar;
  var config = _ref.config,
    api = _ref.api;
  var _ref2 = config !== null && config !== void 0 ? config : {},
    _ref2$showIndentation = _ref2.showIndentationButtons,
    showIndentationButtons = _ref2$showIndentation === void 0 ? false : _ref2$showIndentation,
    _ref2$allowHeadingAnd = _ref2.allowHeadingAndParagraphIndentation,
    allowHeadingAndParagraphIndentation = _ref2$allowHeadingAnd === void 0 ? false : _ref2$allowHeadingAnd;
  var featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
  var primaryToolbarComponent = function primaryToolbarComponent(_ref3) {
    var editorView = _ref3.editorView,
      popupsMountPoint = _ref3.popupsMountPoint,
      popupsBoundariesElement = _ref3.popupsBoundariesElement,
      popupsScrollableElement = _ref3.popupsScrollableElement,
      toolbarSize = _ref3.toolbarSize,
      disabled = _ref3.disabled,
      isToolbarReducedSpacing = _ref3.isToolbarReducedSpacing;
    var isSmall = toolbarSize < ToolbarSize.L;
    return /*#__PURE__*/React.createElement(PrimaryToolbarComponent, {
      featureFlags: featureFlags,
      popupsMountPoint: popupsMountPoint,
      popupsBoundariesElement: popupsBoundariesElement,
      popupsScrollableElement: popupsScrollableElement,
      isSmall: isSmall,
      isToolbarReducedSpacing: isToolbarReducedSpacing,
      disabled: disabled,
      editorView: editorView,
      showIndentationButtons: showIndentationButtons,
      pluginInjectionApi: api,
      allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
    });
  };
  api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
    name: 'toolbarListsIndentation',
    component: primaryToolbarComponent
  });
  return {
    name: 'toolbarListsIndentation',
    primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined
  };
};
export function PrimaryToolbarComponent(_ref4) {
  var _pluginInjectionApi$l;
  var featureFlags = _ref4.featureFlags,
    popupsMountPoint = _ref4.popupsMountPoint,
    popupsBoundariesElement = _ref4.popupsBoundariesElement,
    popupsScrollableElement = _ref4.popupsScrollableElement,
    isSmall = _ref4.isSmall,
    isToolbarReducedSpacing = _ref4.isToolbarReducedSpacing,
    disabled = _ref4.disabled,
    editorView = _ref4.editorView,
    showIndentationButtons = _ref4.showIndentationButtons,
    pluginInjectionApi = _ref4.pluginInjectionApi,
    allowHeadingAndParagraphIndentation = _ref4.allowHeadingAndParagraphIndentation;
  var _useSharedPluginState = useSharedPluginState(pluginInjectionApi, ['list', 'indentation', 'taskDecision']),
    listState = _useSharedPluginState.listState,
    indentationState = _useSharedPluginState.indentationState,
    taskDecisionState = _useSharedPluginState.taskDecisionState;
  var toolbarListsIndentationState = getIndentationButtonsState(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, indentationState, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l = pluginInjectionApi.list) === null || _pluginInjectionApi$l === void 0 ? void 0 : _pluginInjectionApi$l.actions.isInsideListItem);
  if (!listState) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ToolbarListsIndentation, {
    featureFlags: featureFlags,
    isSmall: isSmall,
    isReducedSpacing: isToolbarReducedSpacing,
    disabled: disabled,
    editorView: editorView,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    bulletListActive: listState.bulletListActive,
    bulletListDisabled: listState.bulletListDisabled,
    orderedListActive: listState.orderedListActive,
    orderedListDisabled: listState.orderedListDisabled,
    showIndentationButtons: !!showIndentationButtons,
    indentDisabled: toolbarListsIndentationState.indentDisabled,
    outdentDisabled: toolbarListsIndentationState.outdentDisabled,
    indentationStateNode: toolbarListsIndentationState === null || toolbarListsIndentationState === void 0 ? void 0 : toolbarListsIndentationState.node,
    pluginInjectionApi: pluginInjectionApi
  });
}